import { OrthographicCamera } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import * as THREE from "three";
import { useEffect } from "react";

const Settings = () => {
  const { size, scene } = useThree();

  useEffect(() => {
    // scene.background = new THREE.Color(0x323232);
  }, []);

  return (
    <>
      <OrthographicCamera
        makeDefault
        left={-size.width * 0.5}
        right={size.width * 0.5}
        top={size.height * 0.5}
        bottom={-size.height * 0.5}
        near={1}
        far={10000}
        position={[0, 500, 0]}
        onUpdate={(self) => {
          self.lookAt(0, 0, 0);
        }}
      />
    </>
  );
};

export default Settings;
